export default "__VITE_ASSET__DcrDAi4Y__"